<template>
  <div id="StudyCashAway" class="study">
    <div class="container-fluid head" style="background-color: #439ad0">
      <Header />

      <h1>CashAway</h1>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/CashAway/logo.png" width="90%" class="mb-5" />
        </div>
        <div class="col-12 col-md-6">
          <h2>The Project</h2>
          <p>
            CashAway is a project I created to train myself crafting brand
            identities and meaningful user interfaces.<br />
            As a regular international traveler, one challenge I face is the
            lack of free currency exchange apps. CashAway consists of a digital
            banking application for regular international travelers to spend,
            send and receive payments with no foreign exchange fees around the
            globe.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>Crafting a brand identity</h2>
          <p>
            I combined a variety of shades of celestial blue, steel blue, lapis
            lazuli and white to represent CashAway's brand.<br />
            For the typography I chose to use a sans serif font,
            <i>Lato</i>.<br />
            As for the logo, I wanted to use the two themes of the app: finance
            and travelling. The logo represents a paper boat with its sails in
            the shape of a wallet.
          </p>
          <br />
          <br />
          <img src="/images/CashAway/typography.png" width="100%" />
          <img src="/images/CashAway/colorguide.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/logo_explained.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/logo_variations.png" width="100%" class="mt-5" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>Wireframing</h2>
          <p>
            I used Figma to Wireframe each page of the app. I started by
            wireframing the main screens like the home and registration page. I
            continued by defining other screens that the user goes through after
            log in.
          </p>

          <br />
          <br />
          <img src="/images/CashAway/wireframe.png" width="100%" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>User Interface</h2>
          <img src="/images/CashAway/banner.png" width="100%" />
          <br />
          <br />
          <img src="/images/CashAway/ui1.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/ui2.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/ui3.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/cards_grid.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/cards_stack.png" width="100%" class="mt-5" />
          <img src="/images/CashAway/cards_stack2.png" width="100%" class="mt-5" />
        </div>
      </div>

    </div>
    <Footer />

  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyCashAway",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () { },
};
</script>

<style lang="scss">
#StudyCashAway {
  h2 {
    color: #439ad0;
  }
}
</style>